export const blockIconsActionCalendarToday = (
	<span className='material-symbols-outlined'>calendar_today</span>
);
